export default __webpack_public_path__ + "static/GT-America-Mono-Regular-e93bb7a84e01c3f9a75d8c629e49ffc7.ttf";